import styled, { css } from 'styled-components';
import theme from '../../../../theme';


const Button = styled.button<{
    $hover: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 44px;
    height: 44px;
    border-radius: 44px;
    border: 2px solid ${theme.primaryColor};
    background-color: ${theme.white};
    -webkit-transition: width 1.2s;
    -moz-transition: width 1.2s;
    -ms-transition: width 1.2s;
    -o-transition: width 1.2s;
    transition: width 1.2s;
    box-shadow: 0px 4px 4px 0px #00000040;
    cursor: pointer;

    span {
        font-size: 14px;
        font-weight: 700;
        color: ${theme.primaryColor};
        display: none;
    }

    ${props => props.$hover && css`
        width: 140px;

        span {
            display: block;
        }
    `}

    &:hover {
        background-color: ${theme.primaryColor}10;
        -webkit-transition: 0.3s;
        -moz-transition: 0.3s;
        -ms-transition: 0.3s;
        -o-transition: 0.3s;
        transition: 0.3s;
    }
`;


export { Button };